export default __webpack_public_path__ + "static/media/Add.c8dddb85.svg";